<template>
	<div id="About">
		<div class="content_box">
			<h1>大赛目的</h1>
			<div class="content">{{form.Purpose}}</div>
		</div>
		<div class="content_box">
			<h1>主办单位</h1>
			<div class="content">{{form.Organizers}}</div>
		</div>
		<div class="but_box">
			<mt-button size="small" type="primary" @click="registrants()">个人报名</mt-button>
			<mt-button size="small" type="primary" @click="Shutdown()">团队报名</mt-button>
		</div>
		<h1 class="jury_title">评审团介绍</h1>
		<div class="jury_box">
			<div class="judges" v-for="item of JuryArr" :key='item.name'>
				<div class="imgbox">
					<img v-if="item.FullPhoto" :src="item.FullPhoto" alt="">
				</div>
				<p class="name"><span>{{item.Name}}</span></p>
				<div class="title">
					<div class="title_left">{{item.Descrip}}</div>
					<!-- <div  class="title_right">{{item.position}}</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { MessageBox } from 'mint-ui';
	export default{
		data(){
			return{
				JuryArr:[],
        form:Object,
			}
		},
		created(){
			this.getJury()
			this.getmember()
      this.GetSiteSetting()
		},
		methods:{
			getJury() {
				this.loading = true
				this.$http.get('/api/Jury/GetHomeList')
					.then(response => {

						console.log(response.data.data)
						this.JuryArr = response.data.data
					}).catch(error => {
						console.log(error)
					})
			},
			getmember(){
				this.$http.get('/api/member/GetMember')
				.then(res => {
						this.UserInfo = res.data.data
				})
				.catch(error => {
				  console.log(error)
				})
			},
      GetSiteSetting() {
      	this.$http.get('/api/SiteSetting/GetSiteSetting')
      	.then(response => {
          console.log(response)
          this.form = response.data.data
      	}).catch(error => {
      		console.log(error)
      	})
      },
			Shutdown(){
				var competition_info = JSON.parse(localStorage.getItem('competition_info'))
				if(competition_info){
					if(this.UserInfo.UserName){
						if(competition_info.RegistType == 1||competition_info.RegistType == 2){
							MessageBox('提示', '你已报名，请用电脑浏览器访问http://beijing.top10fp.com进行答题！');
						}else{
							 this.$router.push('/TeamSignUp')
						}
					}else{
						MessageBox.confirm('请先完善个人信息！',{
							confirmButtonClass:'确定',
						}).then(action => {
						  this.$router.push('/editMyCenter')
						});
					}
				}else{
					MessageBox.confirm('请先登录再报名！',{
						confirmButtonClass:'确定',
					}).then(action => {
					  this.$router.push('/login')
					});
				}

			},
			registrants(){
				var competition_info = JSON.parse(localStorage.getItem('competition_info'))
				if(competition_info){
					console.log(this.UserInfo.UserName)
					if(this.UserInfo.UserName){
						if(competition_info.RegistType == 1||competition_info.RegistType == 2){
							MessageBox('提示', '你已报名，请用电脑浏览器访问http://beijing.top10fp.com进行答题！');
						}else{
							MessageBox.confirm('个人参赛将不能参加团队比赛，请确认是否报名！').then(action => {
							  this.$http.post('/api/CompetitionRegist/PesonRegist')
							  .then(res => {
							  		if(res.data.Success){

										MessageBox('提示', '报名成功,请用电脑浏览器访问http://beijing.top10fp.com进行答题');
							  			this.RegistType = 2
							  			var competition_info = JSON.parse(localStorage.getItem('competition_info'))
							  			competition_info.RegistType = 2
							  			localStorage.setItem("competition_info",JSON.stringify(competition_info))
							  		}else{
										MessageBox('提示', res.data.ErrorMsg);
							  		}
							  })
							  .catch(error => {
							    console.log(error)
							  })
							});

						}
					}else{
						MessageBox.confirm('请先完善个人信息！',{
							confirmButtonClass:'确定',
						}).then(action => {
						  this.$router.push('/editMyCenter')
						});
					}
				}else{
					MessageBox.confirm('请先登录再报名！',{
						confirmButtonClass:'确定',
					}).then(action => {
					  this.$router.push('/login')
					});
				}
			},
		}
	}
</script>

<style scoped="scoped" lang="scss">
	#About{
		padding:1rem 0.8rem;box-sizing: border-box;
		.jury_box{
			display: flex;
			flex-wrap: wrap;
			.judges{
				width: 33.3333%;overflow: hidden;
				line-height: 1rem;
				margin-bottom: 20px;
				.imgbox{
					width: 100%;height:6.5rem; margin: 0;
					img{width: 6rem;height: 6rem;border-radius: 50%;}
				}
				.name{
					text-align: center;width: 6rem;font-size: 1rem;margin-bottom: 5px;
				}
				.title{
					text-align: center;width: 6rem;display: flex;justify-content: space-around;flex-wrap: wrap;
				}

			}
			.judges:nth-child(3n+2){
				.imgbox{text-align: center}
				.name{text-align: center;width: 100%}
				.title{
					text-align: center;width: 100%
				}
			}
			.judges:nth-child(3n){
				.imgbox{text-align: right}
				.name{text-align: right;width: 100%;
					span{width: 6rem;text-align: center;display: inline-block}
				}
				.title{
					text-align: right;width: 100%; justify-content: flex-end;

					.title_left{display: inline-block;width: 6rem;text-align: center}
					.title_right{display: inline-block;width: 6rem;text-align: center}
				}
			}
		}

		.content_box{
			h1{text-align: center;font-size: 1rem;margin-bottom: .7rem;}
			.content{margin-bottom: 1.5rem;line-height: 1.2rem;}
		}
		.but_box{
			display: flex;align-items: center;justify-content: space-around;
			padding: 0 1rem;
		}
		.jury_title{
			text-align: center;font-size:1rem;margin: 2rem 0 1rem 0;

		}
	}
</style>



// WEBPACK FOOTER //
// src/components/introduce.vue